var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"width":"225","persistent":""},model:{value:(_vm.loadingOverlay),callback:function ($$v) {_vm.loadingOverlay=$$v},expression:"loadingOverlay"}},[_c('v-card',{staticClass:"pa-10 d-flex flex-column align-center"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }